import { render, staticRenderFns } from "./CardManagement.vue?vue&type=template&id=c98b65e4&scoped=true&"
import script from "./CardManagement.vue?vue&type=script&lang=js&"
export * from "./CardManagement.vue?vue&type=script&lang=js&"
import style0 from "./CardManagement.vue?vue&type=style&index=0&id=c98b65e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98b65e4",
  null
  
)

export default component.exports